"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

exports.__esModule = true;
exports._1822direkt = exports._1822direktMatcher = exports._1822direktParser = exports.getMergedMemo = exports.parseNumber = exports.generateYnabDate = void 0;

require("mdn-polyfills/String.prototype.startsWith");

var papaparse_1 = require("../../util/papaparse");

var read_encoded_file_1 = require("../../util/read-encoded-file");

exports.generateYnabDate = function (input) {
  var match = input.match(/(\d{2})\.(\d{2})\.(\d{4})/);

  if (!match) {
    throw new Error('The input is not a valid date. Expected format: YYYY-MM-DD');
  }

  var day = match[1],
      month = match[2],
      year = match[3];
  return [month.padStart(2, '0'), day.padStart(2, '0'), year].join('/');
};

exports.parseNumber = function (input) {
  return Number(input.replace(/\./g, '').replace(',', '.'));
};

exports.getMergedMemo = function (r) {
  return [r['Vwz.0'], r['Vwz.1'], r['Vwz.2'], r['Vwz.3'], r['Vwz.4'], r['Vwz.5'], r['Vwz.6'], r['Vwz.7'], r['Vwz.8'], r['Vwz.9'], r['Vwz.10'], r['Vwz.11'], r['Vwz.12'], r['Vwz.13'], r['Vwz.14'], r['Vwz.15'], r['Vwz.16'], r['Vwz.17']].filter(Boolean) // When the string is 35 characters long, it's likely to overflow into the next
  // field, so we don't add a space. Otherwise, we add a space for separation.
  .map(function (s) {
    return s.length >= 35 ? s : s + ' ';
  }).join('').trim();
};

exports._1822direktParser = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var fileString, data;

    var _a;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4
          /*yield*/
          , read_encoded_file_1.readEncodedFile(file, 'win1252')];

        case 1:
          fileString = _b.sent();
          return [4
          /*yield*/
          , papaparse_1.parse(fileString, {
            header: true
          })];

        case 2:
          data = _b.sent().data;
          return [2
          /*return*/
          , [{
            accountName: String((_a = data[0]) === null || _a === void 0 ? void 0 : _a.Kontonummer),
            data: data.filter(function (r) {
              return r.Buchungstag && r['Soll/Haben'];
            }).map(function (r) {
              return {
                Date: exports.generateYnabDate(r.Buchungstag),
                Payee: r['Empfänger/Auftraggeber Name'],
                Memo: exports.getMergedMemo(r),
                Outflow: exports.parseNumber(r['Soll/Haben']) < 0 ? (-exports.parseNumber(r['Soll/Haben'])).toFixed(2) : undefined,
                Inflow: exports.parseNumber(r['Soll/Haben']) > 0 ? exports.parseNumber(r['Soll/Haben']).toFixed(2) : undefined
              };
            })
          }]];
      }
    });
  });
};

exports._1822direktMatcher = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var requiredKeys, rawFileString, data, keys_1, missingKeys, e_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          requiredKeys = ['Buchungstag', 'Soll/Haben', 'Vwz.0', 'Empfänger/Auftraggeber Name'];
          return [4
          /*yield*/
          , read_encoded_file_1.readEncodedFile(file, 'win1252')];

        case 1:
          rawFileString = _a.sent();

          if (rawFileString.startsWith('Kontonummer;Datum/Zeit;Buchungstag;Wertstellung;Soll/Haben;Buchungsschlüssel;Buchungsart;Empfänger/Auftraggeber Name;Empfänger/Auftraggeber IBAN;Empfänger/Auftraggeber BIC;Glaeubiger-ID;')) {
            return [2
            /*return*/
            , true];
          }

          if (rawFileString.length === 0) {
            return [2
            /*return*/
            , false];
          }

          _a.label = 2;

        case 2:
          _a.trys.push([2, 4,, 5]);

          return [4
          /*yield*/
          , papaparse_1.parse(rawFileString, {
            header: true
          })];

        case 3:
          data = _a.sent().data;

          if (data.length === 0) {
            return [2
            /*return*/
            , false];
          }

          keys_1 = Object.keys(data[0]);
          missingKeys = requiredKeys.filter(function (k) {
            return !keys_1.includes(k);
          });

          if (missingKeys.length === 0) {
            return [2
            /*return*/
            , true];
          }

          return [3
          /*break*/
          , 5];

        case 4:
          e_1 = _a.sent();
          return [2
          /*return*/
          , false];

        case 5:
          return [2
          /*return*/
          , false];
      }
    });
  });
};

exports._1822direkt = {
  name: '1822direkt',
  country: 'de',
  fileExtension: 'csv',
  filenamePattern: /^umsaetze-\d+-\d{2}\.\d{2}.\d{4}_\d{2}_\d{2}\.csv$/,
  link: 'https://www.1822direkt.de/',
  match: exports._1822direktMatcher,
  parse: exports._1822direktParser
};